import React, { Fragment, useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import Table from "react-bootstrap/Table";
import { AxisDateTimeFull } from "../util/AxisDateTime";
import { UserLink } from "../util/Links";
import { ShiftTableTitle } from "./ShiftTableTitle";
import AxisSpinner from "../components/AxisSpinner";

const ShiftCancellationsElement = ({ shift }) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);
  const [cancellations, setCancellations] = useState([]);

  useEffect(() => {
    fetch();
  }, [shift]);

  const fetch = async () => {
    try {
      setLoading(true);

      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {
          shift_id: shift?.id,
        },
      };

      const response = await authAxios().get(
        "/api/backoffice/shifts/" +
          (shift?.table === "shifts"
            ? "active_cancellations"
            : "archive_cancellations"),
        config,
      );
      setLoading(false);

      setCancellations(response.data);
    } catch (error) {
      setLoading(false);
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
    }
  };

  const SpinnerOrData = () => {
    if (cancellations?.length === 0) return;
    return (
      <Fragment>
        <ShiftTableTitle title={"Associated Cancellations"} />
        <Table striped hover responsive>
          <thead>
            <tr>
              <th>User</th>
              <th>Cancelled By</th>
              <th>Reason</th>
              <th>Timestamp</th>
            </tr>
          </thead>
          <tbody>
            {cancellations?.map((cancel) => (
              <tr key={cancel?.id}>
                <td>{UserLink(cancel?.user)}</td>
                <td>
                  {cancel?.cancelledBy?.id !== null &&
                  cancel?.cancelledBy?.id !== undefined
                    ? UserLink(cancel?.cancelledBy)
                    : "Trust"}
                </td>
                <td>{cancel?.reason}</td>
                <td>{AxisDateTimeFull(cancel?.created)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Fragment>
    );
  };

  return <Fragment>{SpinnerOrData()}</Fragment>;
};

export default ShiftCancellationsElement;
